import { render } from "./ProductVariationForm.vue?vue&type=template&id=fc8518d0&scoped=true&ts=true"
import script from "./ProductVariationForm.vue?vue&type=script&lang=ts"
export * from "./ProductVariationForm.vue?vue&type=script&lang=ts"

import "./ProductVariationForm.vue?vue&type=style&index=0&id=fc8518d0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8518d0"]])

export default __exports__